'use client';

import { useEffect } from 'react';
import { GOOGLE_TAG_ENABLED } from '@/features/Analytics/featureFlags';
import { useCookieConsent } from '@/features/Legal/cookieConsent';
import { applyGoogleAdsConsent, initGoogleAds } from './googleAds';

export function GoogleAdsHost() {
  const consent = useCookieConsent();

  useEffect(() => {
    if (!GOOGLE_TAG_ENABLED || consent === undefined) return;
    initGoogleAds();
    applyGoogleAdsConsent(consent);
  }, [consent]);

  return null;
}
